import type { HTMLProps, LegacyRef } from 'react';
import { forwardRef } from 'react';

export interface NavProps extends HTMLProps<HTMLDivElement> {
  side?: 'top' | 'bottom' | 'left' | 'right' | 'unside';
}

function NavComponent(
  { children, side = 'unside', ...props }: NavProps,
  ref: LegacyRef<HTMLDivElement>
) {
  return (
    <nav
      ref={ref}
      {...props}
      className={`nav nav-${side} ${props.className || ''}`}
    >
      {children}
    </nav>
  );
}

export default forwardRef(NavComponent);
